import React from 'react';
import { Trash2, Package } from 'lucide-react';
import QuantitySelector from './QuantitySelector';

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  const { product, quantity } = item;
  const { name, image, weight, price, offer_price, current_price } = product;

  // Usar current_price del backend (precio final calculado)
  const finalPrice = current_price || (offer_price && offer_price < price ? offer_price : price);
  const subtotal = finalPrice * quantity;

  return (
    <div className="flex gap-4 bg-white p-4 rounded-2xl shadow-md">
      {/* Product Image */}
      <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden bg-[#F8F7F5]">
        {image ? (
          <img
            src={image}
            alt={name}
            loading="lazy"
            decoding="async"
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[#BCB8B1]">
            <Package size={24} />
          </div>
        )}
      </div>

      {/* Product Info */}
      <div className="flex-1 min-w-0">
        <h4 className="font-display font-bold text-[#1B263B] truncate mb-0.5">
          {name}
        </h4>
        {weight && (
          <p className="text-xs text-[#7A756F] mb-2">
            {weight}
          </p>
        )}
        <p className="text-sm font-semibold text-[#E85D04] mb-2">
          ${finalPrice.toLocaleString()} c/u
        </p>

        {/* Quantity and Actions */}
        <div className="flex items-center justify-between">
          <QuantitySelector
            value={quantity}
            onChange={(newQty) => onUpdateQuantity(product.id, newQty)}
            min={1}
            max={product.stock}
            size="sm"
          />
          
          <div className="flex items-center gap-3">
            <span className="font-display font-bold text-[#1B263B]">
              ${subtotal.toLocaleString()}
            </span>
            
            <button
              onClick={() => onRemove(product.id)}
              className="p-2 text-[#9A9590] hover:text-[#DC2626] hover:bg-red-50 rounded-xl transition-colors touch-manipulation"
              aria-label="Eliminar producto"
            >
              <Trash2 size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItem;
